export default __webpack_public_path__ + "static/media/anna.dbfcadb2.mp3";